import React from 'react'

import SelectLocationLayout from 'presentation/doctor/layouts/AddSurgicalOrderNew/SelectLocation'

const SelectLocation = () => <SelectLocationLayout />

export default SelectLocation
